module.exports = __webpack_public_path__ + "static/the-untethered-soul-easyread-super-large-24pt-edition-b62d0fc549617d910eba3f6d7ec9593f.jpg";